function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/panel/sticky/stickypanelview
 */
import global from '@ckeditor/ckeditor5-utils/src/dom/global';
import View from '../../view';
import Template from '../../template';
import toUnit from '@ckeditor/ckeditor5-utils/src/dom/tounit';
import '../../../theme/components/panel/stickypanel.css';
var toPx = toUnit('px');
/**
 * The sticky panel view class.
 */

var StickyPanelView = /*#__PURE__*/function (_View) {
  _inherits(StickyPanelView, _View);

  var _super = _createSuper(StickyPanelView);

  /**
   * @inheritDoc
   */
  function StickyPanelView(locale) {
    var _this;

    _classCallCheck(this, StickyPanelView);

    _this = _super.call(this, locale);
    var bind = _this.bindTemplate;
    /**
     * Controls whether the sticky panel should be active.
     *
     * @readonly
     * @observable
     * @member {Boolean} #isActive
     */

    _this.set('isActive', false);
    /**
     * Controls whether the sticky panel is in the "sticky" state.
     *
     * @readonly
     * @observable
     * @member {Boolean} #isSticky
     */


    _this.set('isSticky', false);
    /**
     * The limiter element for the sticky panel instance. Its bounding rect limits
     * the "stickyness" of the panel, i.e. when the panel reaches the bottom
     * edge of the limiter, it becomes sticky to that edge and does not float
     * off the limiter. It is mandatory for the panel to work properly and once
     * set, it cannot be changed.
     *
     * @readonly
     * @observable
     * @member {HTMLElement} #limiterElement
     */


    _this.set('limiterElement', null);
    /**
     * The offset from the bottom edge of {@link #limiterElement}
     * which stops the panel from stickying any further to prevent limiter's content
     * from being completely covered.
     *
     * @readonly
     * @observable
     * @default 50
     * @member {Number} #limiterBottomOffset
     */


    _this.set('limiterBottomOffset', 50);
    /**
     * The offset from the top edge of the web browser's viewport which makes the
     * panel become sticky. The default value is `0`, which means the panel becomes
     * sticky when it's upper edge touches the top of the page viewport.
     *
     * This attribute is useful when the web page has UI elements positioned to the top
     * either using `position: fixed` or `position: sticky`, which would cover the
     * sticky panel or vice–versa (depending on the `z-index` hierarchy).
     *
     * @readonly
     * @observable
     * @default 0
     * @member {Number} #viewportTopOffset
     */


    _this.set('viewportTopOffset', 0);
    /**
     * Controls the `margin-left` CSS style of the panel.
     *
     * @protected
     * @readonly
     * @observable
     * @member {String} #_marginLeft
     */


    _this.set('_marginLeft', null);
    /**
     * Set `true` if the sticky panel reached the bottom edge of the
     * {@link #limiterElement}.
     *
     * @protected
     * @readonly
     * @observable
     * @member {Boolean} #_isStickyToTheLimiter
     */


    _this.set('_isStickyToTheLimiter', false);
    /**
     * Set `true` if the sticky panel uses the {@link #viewportTopOffset},
     * i.e. not {@link #_isStickyToTheLimiter} and the {@link #viewportTopOffset}
     * is not `0`.
     *
     * @protected
     * @readonly
     * @observable
     * @member {Boolean} #_hasViewportTopOffset
     */


    _this.set('_hasViewportTopOffset', false);
    /**
     * Collection of the child views which creates balloon panel contents.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */


    _this.content = _this.createCollection();
    /**
     * The DOM bounding client rect of the {@link module:ui/view~View#element} of the panel.
     *
     * @protected
     * @member {Object} #_panelRect
     */

    /**
     * The DOM bounding client rect of the {@link #limiterElement}
     * of the panel.
     *
     * @protected
     * @member {Object} #_limiterRect
     */

    /**
     * A dummy element which visually fills the space as long as the
     * actual panel is sticky. It prevents flickering of the UI.
     *
     * @protected
     * @property {HTMLElement}
     */

    _this._contentPanelPlaceholder = new Template({
      tag: 'div',
      attributes: {
        class: ['ck', 'ck-sticky-panel__placeholder'],
        style: {
          display: bind.to('isSticky', function (isSticky) {
            return isSticky ? 'block' : 'none';
          }),
          height: bind.to('isSticky', function (isSticky) {
            return isSticky ? toPx(_this._panelRect.height) : null;
          })
        }
      }
    }).render();
    /**
     * The panel which accepts children into {@link #content} collection.
     * Also an element which is positioned when {@link #isSticky}.
     *
     * @protected
     * @property {HTMLElement}
     */

    _this._contentPanel = new Template({
      tag: 'div',
      attributes: {
        class: ['ck', 'ck-sticky-panel__content', // Toggle class of the panel when "sticky" state changes in the view.
        bind.if('isSticky', 'ck-sticky-panel__content_sticky'), bind.if('_isStickyToTheLimiter', 'ck-sticky-panel__content_sticky_bottom-limit')],
        style: {
          width: bind.to('isSticky', function (isSticky) {
            return isSticky ? toPx(_this._contentPanelPlaceholder.getBoundingClientRect().width) : null;
          }),
          top: bind.to('_hasViewportTopOffset', function (_hasViewportTopOffset) {
            return _hasViewportTopOffset ? toPx(_this.viewportTopOffset) : null;
          }),
          bottom: bind.to('_isStickyToTheLimiter', function (_isStickyToTheLimiter) {
            return _isStickyToTheLimiter ? toPx(_this.limiterBottomOffset) : null;
          }),
          marginLeft: bind.to('_marginLeft')
        }
      },
      children: _this.content
    }).render();

    _this.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck', 'ck-sticky-panel']
      },
      children: [_this._contentPanelPlaceholder, _this._contentPanel]
    });

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(StickyPanelView, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      _get(_getPrototypeOf(StickyPanelView.prototype), "render", this).call(this); // Check if the panel should go into the sticky state immediately.


      this._checkIfShouldBeSticky(); // Update sticky state of the panel as the window is being scrolled.


      this.listenTo(global.window, 'scroll', function () {
        _this2._checkIfShouldBeSticky();
      }); // Synchronize with `model.isActive` because sticking an inactive panel is pointless.

      this.listenTo(this, 'change:isActive', function () {
        _this2._checkIfShouldBeSticky();
      });
    }
    /**
     * Analyzes the environment to decide whether the panel should
     * be sticky or not.
     *
     * @protected
     */

  }, {
    key: "_checkIfShouldBeSticky",
    value: function _checkIfShouldBeSticky() {
      var panelRect = this._panelRect = this._contentPanel.getBoundingClientRect();

      var limiterRect;

      if (!this.limiterElement) {
        this.isSticky = false;
      } else {
        limiterRect = this._limiterRect = this.limiterElement.getBoundingClientRect(); // The panel must be active to become sticky.

        this.isSticky = this.isActive && // The limiter's top edge must be beyond the upper edge of the visible viewport (+the viewportTopOffset).
        limiterRect.top < this.viewportTopOffset && // The model#limiterElement's height mustn't be smaller than the panel's height and model#limiterBottomOffset.
        // There's no point in entering the sticky mode if the model#limiterElement is very, very small, because
        // it would immediately set model#_isStickyToTheLimiter true and, given model#limiterBottomOffset, the panel
        // would be positioned before the model#limiterElement.
        this._panelRect.height + this.limiterBottomOffset < limiterRect.height;
      } // Stick the panel to the top edge of the viewport simulating CSS position:sticky.
      // TODO: Possibly replaced by CSS in the future http://caniuse.com/#feat=css-sticky


      if (this.isSticky) {
        this._isStickyToTheLimiter = limiterRect.bottom < panelRect.height + this.limiterBottomOffset + this.viewportTopOffset;
        this._hasViewportTopOffset = !this._isStickyToTheLimiter && !!this.viewportTopOffset;
        this._marginLeft = this._isStickyToTheLimiter ? null : toPx(-global.window.scrollX);
      } // Detach the panel from the top edge of the viewport.
      else {
          this._isStickyToTheLimiter = false;
          this._hasViewportTopOffset = false;
          this._marginLeft = null;
        }
    }
  }]);

  return StickyPanelView;
}(View);

export { StickyPanelView as default };